import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { RolePermissionService } from '~app/services/role-permission.service';

@Injectable({
  providedIn: 'root',
})
export class HasTeamMembershipGuard {
  constructor(
    private rolePermissionService: RolePermissionService,
    private router: Router
  ) {}
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | boolean {
    return this.rolePermissionService.hasTeamMembership$.pipe(
      take(1),
      map(
        (hasMembership) =>
          hasMembership || this.router.parseUrl('/limited-access')
      )
    );
  }
}
